/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';
import { buildRequestPartsFromPayload } from '../../utils';
import utils from '../../../../common/utils';

export default class GraphsService extends BaseService {
  constructor() {
    super(constants.GET_GRAPHS_LIST, constants.GET_GRAPHS_LIST_STATUS);
  }

  async handleEvent(eventName, event) {
    const urlEndpoint = constants.GRAPHS_LIST_ENDPOINT;
    const { headers } = buildRequestPartsFromPayload(event);
    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').get(urlEndpoint, { headers: enhancedHeaders });
    }
    return this.getClient('aiadmin').get(urlEndpoint, { headers });
  }

  handleResponse(response) {
    Framework.getStoreRegistry().getStore('graphs').setResponse(response.data);
  }

  handleError(error) {
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        // Handle unauthorized access
        console.error('Unauthorized access to graphs API');
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message || 'Failed to fetch graphs',
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState')?.set(notification);
      }
    }
    Framework.getStoreRegistry().getStore('graphs').resetStoreValues();
  }
}
